<template>
	<div>
		<div class="search">
			<el-form :inline="true" class="searchForm" ref="form" :rules="rule" :model="form">
				<el-form-item style="margin-top: 15px" label="加点方案名称" prop="NAME">
					<el-input size="medium" v-model="form.NAME"></el-input>
				</el-form-item>
				<el-form-item style="margin-top: 15px" label="默认加点" prop="SCHEME_POINT">
					<el-input size="medium" v-model="form.SCHEME_POINT"><template slot="append">%</template></el-input>
				</el-form-item>
				<el-form-item style="margin-top: 15px" label="是否为缺省方案" prop="BE_DEFAULT">
					<el-checkbox size="medium" v-model="form.BE_DEFAULT"></el-checkbox>
				</el-form-item>
			</el-form>
		</div>
		<div class="middle">
			<el-button style="margin-left: 20px" size="medium" @click="handleNewAddPoint('form')">提交</el-button>
		</div>
		<div style="padding: 15px 20px;background:white;border-radius:3px">
			<el-tabs v-model="activeName" type="card">
				<el-tab-pane v-for="(item, index) in treeData" :label="item.CATEGORY_NAME" :key="item.CATALOG_CODE"
					style="height:400px;overflow-y:auto">
					<el-row>
						<el-col>
							<el-form>
								<el-form-item label="快速设置点数:">
									<span style="width: 100px;"></span>
									<el-input size="medium" v-model="item.POINT" style="width: 200px"><template
											slot="append">%</template></el-input>
									<el-button size="medium" style="width:80px"
										@click="handleRapidSet(index)">设置</el-button>
								</el-form-item>
							</el-form>
						</el-col>
					</el-row>
					<el-row style="margin-top:10px">
						<span v-for="(second, index) in item.children" :key="second.CATALOG_CODE">
							<el-col :xl="6" :lg="6" :md="8" :sm="12">
								<el-form>
									<el-form-item label-width="100px">
										<label slot="label">{{ second.CATEGORY_NAME }}:</label>
										<el-input v-model="item.children[index].POINT"
											style="width:200px;margin-top: 0"><template
												slot="append">%</template></el-input>
									</el-form-item>
								</el-form>
								<!--<span style="display:inline-block;width:80px">{{second.label}}</span>-->
								<!--<el-input v-model="item.children[index].POINT" style="width:150px;margin-top: 0" ><template slot="append">%</template></el-input>-->
							</el-col>
						</span>
					</el-row>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      form: {
        NAME: '',
        BE_DEFAULT: false,
        SCHEME_POINT: '',
      },
      rule: {
        NAME: [{ required: true, message: '请输入方案名称', trigger: 'blur' }],
        SCHEME_POINT: [{ required: true, message: '请输入加点级别', trigger: 'blur' }],
      },
      treeData: [],
      activeName: '',
      // rapidSet: 6,
    };
  },
  methods: {
    handleNewAddPoint(formName) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          // console.log(this.treeData)
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.treeData.forEach((item) => {
                item.POINT = item.POINT === undefined ? 0 : Number(item.POINT);
                item.children.forEach((itemChildren) => {
                  itemChildren.POINT = itemChildren.POINT === undefined ? 0 : Number(itemChildren.POINT);
                  // console.log(itemChildren.POINT)
                });
              });
              const flag = this.treeData.find((item) => {
                const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
                if (!reg.test(item.POINT)) {
                  return true;
                }
              });
              if (flag) {
                this.$message.show({ text: '请输入正数加点', type: 'warning' });
                document.body.style.cursor = 'default';
                return false;
              }
              const params = {
                SERVICE_ID: '10023',
                OTYPE: 9,
                GYS_ID: Number(sessionStorage.getItem('tcId')),
                SCHEME_NAME: this.form.NAME,
                DEFAULT_POINT: this.form.SCHEME_POINT,
                BE_DEFAULT: Number(this.form.BE_DEFAULT),
                SCHEME_DATA: this.treeData,
                SCHEME_ID: this.$route.params.SCHEME_ID,
              };
              http
                .post(params)
                .then((result) => {
                  this.$message.show({ text: '新增加点方案成功', type: 'success' });
                  this.$router.push({ path: '/priceRules' });
                  document.body.style.cursor = 'default';
                })
                .catch((error) => {
                  this.$message.show({ text: error, type: 'error' });
                  document.body.style.cursor = 'default';
                });
            } else {
              // console.log('5555')
              this.$message.show({
                text: '信息未填写完整，添加失败！',
                type: 'error',
              });
              document.body.style.cursor = 'default';
            }
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    queryProductCatalog() {
      // console.log('this.$route.params.SCHEME_ID', this.$route.params.SCHEME_ID)
      const params = {
        SERVICE_ID: '10023',
        OTYPE: 8,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SCHEME_ID: this.$route.params.SCHEME_ID,
      };
      http
        .post(params)
        .then((result) => {
          // console.log('queryProductCatalog result', result)
          this.treeData = result[0].DETAIL.length > 0 ? result[0].DETAIL : [];
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    handleRapidSet(index) {
      this.$confirm('该操作会更改当前大类下所有加点数，确定么？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.treeData[index].children.forEach((child) => {
          this.$set(child, 'POINT', this.treeData[index].POINT);
        });
      }).catch((error) => {
        // console.log(error)
      });
    },
    close() {
      this.$router.back();
    },
    queryUpdateProductCatalog(id) {
      const params = {
        SERVICE_ID: '10023',
        OTYPE: 8,
        SCHEME_ID: id,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      http
        .post(params)
        .then((result) => {
          // console.log('queryUpdateProductCatalog result', result)
          this.treeData = result[0].DETAIL.length > 0 ? result[0].DETAIL : [];
          this.form.NAME = result[0].NAME;
          this.form.BE_DEFAULT = Boolean(result[0].BE_DEFAULT);
          this.form.SCHEME_POINT = result[0].DEFAULT_POINT;
          // console.log(this.treeData)
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
  },
  mounted() {
    this.queryProductCatalog();
    // console.log('this.$route',this.$route)
    this.form.SCHEME_POINT = this.$route.params.SCHEME_POINT;
    this.form.NAME = this.$route.params.SCHEME_NAME;
  },
};
</script>

<style scoped>
.SCHEME_POINT {
	width: 222px !important;
}

.middle {
	width: 100%;
	height: 60px;
	line-height: 60px;
	background-color: #f5f7f9;
	padding-left: 20px;
	margin: 0 -20px 0 -20px;
}

.search {
	width: 100%;
}

.searchForm {
	background: white;
	border-radius: 3px;
	padding: 10px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/priceManagement/newAddPrice.vue